import { defineMessages } from 'react-intl';

export default defineMessages({
    firstName: {
        id: 'auth.components.SignUp.First Name:',
        defaultMessage: 'First Name:'
    },
    lastName: {
        id: 'auth.components.SignUp.Last Name:',
        defaultMessage: 'Last Name:'
    },
    emailAddress: {
        id: 'auth.components.SignUp.Email:',
        defaultMessage: 'Email:'
    },
    password: {
        id: 'auth.components.SignUp.Password:',
        defaultMessage: 'Password:'
    },
    confirmPassword: {
        id: 'auth.components.SignUp.Confirm Password:',
        defaultMessage: 'Confirm Password:'
    },
    signUp: {
        id: 'auth.components.SignUp.Sign Up',
        defaultMessage: 'Sign Up'
    },
    fieldEmpty: {
        id: 'auth.components.SignUp.All fields are required to sign up.',
        defaultMessage: 'All fields are required to sign up.'
    },
    invalidEmail: {
        id: 'auth.components.SignUp.Please enter a valid email address.',
        defaultMessage: 'Please enter a valid email address.'
    },
    passwordsNotMatching: {
        id: 'auth.components.SignUp.Fields password and confirmation password do not match.',
        defaultMessage: 'Fields password and confirmation password do not match.'
    },
    emailAlreadyExists: {
        id: 'auth.components.SignUp.Email already exists',
        defaultMessage: 'Email already exists'
    },
    emailAlreadyExistsDescription: {
        id: 'auth.components.SignUp.An account with the email address you entered already exists.',
        defaultMessage: 'An account with the email address you entered already exists.'
    },
    invalidAttempt: {
        id: 'auth.components.SignUp.Invalid Attempt',
        defaultMessage: 'Invalid Attempt'
    },
    unableToCreateUserAccount: {
        id: 'auth.components.SignUp.Unable to create user account',
        defaultMessage: 'Unable to create user account'
    },
    unableToLoginAutomatically: {
        id: 'auth.components.SignUp.Unable to login automatically',
        defaultMessage: 'Unable to login automatically'
    },
    unableToLoginAutomaticallyDescription: {
        id: 'auth.components.SignUp.Account successfully created, however, not able to login automatically. Please return to Sign In and enter your email and password.',
        defaultMessage: 'Account successfully created, however, not able to login automatically. Please return to Sign In and enter your email and password.'
    },
    doYouHaveAccount: {
        id: 'auth.components.SignUp.Already have an account?',
        defaultMessage: 'Already have an account?'
    },
    signIn: {
        id: 'auth.components.SignUp.Sign In',
        defaultMessage: 'Sign In'
    },
    phoneNumber: {
        id: 'auth.components.phoneNumber.Phone Number',
        defaultMessage: 'Phone Number'
    },
    passwordRule1 : {
        id: "auth.components.signup.passwordRule1",
        defaultMessage: "At least 10 characters long"
    },
    passwordRule2 : {
        id: "auth.components.signup.passwordRule2",
        defaultMessage: "Includes at least one capital letter"
    },
    passwordRule3 : {
        id: "auth.components.signup.passwordRule3",
        defaultMessage: "Includes at least one lower case letter"
    },
    passwordRule4 : {
        id: "auth.components.signup.passwordRule4",
        defaultMessage: "Includes at least one numeric digit"
    },
    passwordRule5 : {
        id: "auth.components.signup.passwordRule5",
        defaultMessage: "Includes at least one special character"
    },
    passwordRuleError : {
        id : "auth.components.signup.Password does not meet the criteria.",
        defaultMessage: "Password does not meet the criteria."
    },
    passwordRules: {
        id: "auth.components.signup.passwordRule",
        defaultMessage: "Password must contain at least 10 characters long, one capital letter, one lower case letter, one numeric digit, one special character @$!%*#?&"
    },
	existingAccountErrorMsg: {
        id: "auth.components.SignUp.An account with the email provided may already exist. If this is a new policy, you may have been automatically registered. Please reset your password here to access your account.",
        defaultMessage: "An account with the email provided may already exist. If this is a new policy, you may have been automatically registered. Please reset your password {here} to access your account."
    },
    here: {
        id: "auth.components.SignUp.here",
        defaultMessage: "here"
    },
    showPasswordCheckBox:{
        id:"auth.components.signup.ShowPassword",
        defaultMessage:"Show Password"
    }
});
